module.exports = __webpack_public_path__ + "register/img/membership-core.0233f47a.svg";